export default "__VITE_ASSET__CSzhl8rK__"